export const ONE_MILLI_SECOND = 1000;
export const DELETED_COMPANY = 'Removed company';
